import React, {Component} from 'react';

import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import brownmoon from 'assets/images/norming/rapidNaming/moon_brown-min.png';
import redstar from 'assets/images/norming/rapidNaming/stjerne_red-min.png';
import blueapple from 'assets/images/norming/rapidNaming/eple_bla-min.png';
import yellowcake from 'assets/images/norming/rapidNaming/kake_yellow-min.png';
import gronnsykkel from 'assets/images/norming/rapidNaming/sykkel_gronn-min.png';

import gragenser from 'assets/images/rapidNaming/gragenser.png';
import graeple from 'assets/images/rapidNaming/graeple.png';
import gratommel from 'assets/images/rapidNaming/gratommel.png';
import grasykkel from 'assets/images/rapidNaming/grasykkel.png';
import grabamse from 'assets/images/rapidNaming/grabamse.png';
import blatommel from 'assets/images/rapidNaming/blatommel.png';
import oransjeeple from 'assets/images/rapidNaming/oransjeeple.png';
import rodgenser from 'assets/images/rapidNaming/rodgenser.png';

import {no, nn, noNorming, nnNorming} from './assets';

import strings from 'strings';
import {TYPES} from '../../constants/index';

class Intro extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = isNormingTest ? nnNorming : nn;
				break;
			case 'no':
				this.assets = isNormingTest ? noNorming : no;
				break;
			default:
				this.assets = no;
				break;
		}

		this.state = {
			stepData: {},
			hasCorrectWordsGiven: false,
			step: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		if (this.props.currentStep !== newProps.currentStep) {
			this.setState({step: newProps.currentStep});
		}
		if (this.props.stepData !== newProps.stepData) {
			const hasCorrectWordsGiven =
				newProps.stepData.hasOwnProperty('correctWordsGiven') &&
				newProps.stepData.correctWordsGiven;

			if (!this.state.hasCorrectWordsGiven && hasCorrectWordsGiven) {
				this.setState({
					hasCorrectWordsGiven,
				});
				this.playSecondClip();
			}
		}
	}

	playSecondClip = () => {
		if (this.audio2) this.audio2.handleStartPlayer();
	};

	render() {
		const step = this.state.step;
		const {testKeyType, ageGroup} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="RapidNamingIntro">
				{isNormingTest ? (
					<>
						{step === 0 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro1}
									/>
									{strings.rn_norming_intro1}
								</p>
								<div className="items">
									<img
										className="image"
										src={redstar}
										alt=""
									/>
									<img
										className="image"
										src={blueapple}
										alt=""
									/>
									<img
										className="image"
										src={gronnsykkel}
										alt=""
									/>
									<img
										className="image"
										src={brownmoon}
										alt=""
									/>
									<img
										className="image"
										src={yellowcake}
										alt=""
									/>
								</div>
							</>
						)}
						{step === 1 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro5}
									/>
									{strings.rn_intro5_norming}
								</p>
							</>
						)}
					</>
				) : (
					<>
						{step === 0 && (
							<p>
								<AudioPlayer
									autoplay
									inline
									src={this.assets.intro1}
								/>
								{strings.rn_intro1}
							</p>
						)}
						{step === 1 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro2}
									/>
									{strings.rn_intro2}
								</p>
								<div className="items">
									<div className="circle red" />
									<div className="circle blue" />
									<div className="circle green" />
									<div className="circle gray" />
									<div className="circle orange" />
								</div>
							</>
						)}
						{step === 2 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro3}
									/>
									{strings.intro3}
								</p>
								<div className="items">
									<img
										className="image"
										src={gratommel}
										alt=""
									/>
									<img
										className="image"
										src={graeple}
										alt=""
									/>
									<img
										className="image"
										src={grasykkel}
										alt=""
									/>
									<img
										className="image"
										src={gragenser}
										alt=""
									/>
									<img
										className="image"
										src={grabamse}
										alt=""
									/>
								</div>
							</>
						)}
						{step === 3 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro4}
									/>
									{strings.intro4}
								</p>
								<div className="items">
									<img
										className="image"
										src={blatommel}
										alt=""
									/>
									<img
										className="image"
										src={oransjeeple}
										alt=""
									/>
									<img
										className="image"
										src={gronnsykkel}
										alt=""
									/>
									<img
										className="image"
										src={rodgenser}
										alt=""
									/>
									<img
										className="image"
										src={grabamse}
										alt=""
									/>
								</div>
							</>
						)}
						{step === 4 && (
							<>
								<p>
									<AudioPlayer
										ref={(node) => (this.audio2 = node)}
										inline
										autoplay
										src={this.assets.intro5}
									/>
									{strings.rn_intro5}
								</p>
								<ReadyButton
									onReadyChange={this.props.setReady}
								/>
							</>
						)}
					</>
				)}
			</div>
		);
	}
}

export default Intro;
